import React from "react";
import styled from "styled-components";

// head de acciones en los views
export default function HeadView(props) {
   return (
      <StyledHead>
         <div className="leftChild">{props.children[0]}</div>
         <div className="rightChild">{props.children[1]}</div>
      </StyledHead>
   );
}

const StyledHead = styled.div`
   display: grid;
   grid-template-columns: 1fr 1fr 1fr;
   grid-template-rows: 1fr;
   margin-bottom: 2em;
   // background: rgba(100, 20, 50, 0.6);

   & .leftChild {
      grid-area: 1 / 1 / span 1 / span 1;
      // background: red;
      display: flex;
      align-items: center;
   }
   & .rightChild {
      grid-area: 1 / 3 / span 1 / span 1;
      // background: blue;
      display: flex;
      justify-content: flex-end;
      align-items: center;
   }
`;
